export default __webpack_public_path__ + "static/media/bvround.a116e386.svg";